import { Menu } from '@mui/material';
import Button from '../../Button';
import TimePickerFormInput from '../../TimePickerFormInput';
import { Element } from '../_definitions/ActionGroupDefinitions';
/* ********************************************************************************************* */
/* This utility contains commonly used useful functions.                                         */
/* ********************************************************************************************* */
/**
 * Returns a value of the specified CSS property of the specified node/element.
 *
 * @param nodeStyle The CSS style object.
 * @param styleProp The style property to get the value from.
 * @returns The value of the style property.
 */
export var getStyleValue = function (nodeStyle, styleProp) {
    return parseInt(nodeStyle.getPropertyValue(styleProp), 10) || 0;
};
/**
 * Returns the subtype of the specified `Item`'s element. Each element might have a different way how to access to it.
 * Currently only the pickers support/require this feature.
 *
 * @param agItemElement The `Item`'s element to check.
 * @returns The subtype of the respective element's type, or `undefined` if the element doesn't support it.
 */
export var getElementSubtype = function (agItemElement) {
    var subtype;
    switch (agItemElement === null || agItemElement === void 0 ? void 0 : agItemElement.type) {
        case TimePickerFormInput:
            // Either get the component or the default one.
            subtype = agItemElement === null || agItemElement === void 0 ? void 0 : agItemElement.props.Component;
            break;
        default:
        // Do nothing.
    }
    return subtype;
};
/**
 * Returns an `Element` which matches the specified `Item`'s element. Optionally some items (typically Pickers) might
 * contain also subtypes to further specify the condition.
 *
 * @param agItemElement The `Item`'s element to check.
 * @returns An `Element` which matches the specified item's element or `undefined` if no match found.
 */
export var getElement = function (agItemElement) {
    var elSubtype = getElementSubtype(agItemElement);
    return Object.values(Element).find(function (el) { return el.type === agItemElement.type && el.subtype === elSubtype; });
};
/**
 * Checks if the specified element type is a `styled` component.
 *
 * @param elType The element type to check.
 * @returns `true` if the specified element type's display name is a styled component, `false` otherwise.
 */
export var isStyledComponent = function (elType) { var _a, _b, _c; return ((_a = elType === null || elType === void 0 ? void 0 : elType.displayName) === null || _a === void 0 ? void 0 : _a.startsWith('Styled(')) || ((_c = (_b = elType === null || elType === void 0 ? void 0 : elType.render) === null || _b === void 0 ? void 0 : _b.displayName) === null || _c === void 0 ? void 0 : _c.startsWith('Styled(')); };
/**
 * Checks if the specified element is of type dropdown button, i.e. if it is a `React.Fragment` consisting of
 * `Button` and `Menu` components. Note that it is assumed that the button is the first in the list.
 *
 * @param element The element to check.
 * @returns `true` if the specified element is a dropdown button with a menu, `false` otherwise.
 */
export var isDropdownButton = function (element) {
    var _a;
    return (Array.isArray(element) &&
        (element === null || element === void 0 ? void 0 : element.length) === 2 &&
        ((_a = element[0]) === null || _a === void 0 ? void 0 : _a.type) === Button &&
        element[1].type === Menu);
};
